var React = require('react');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var Shopify = require('./shopify');
var TopBigImg = require('./header-full');
var SeasonSales = require('./image-on-left');
var ScrollToTop = require('./scroll-to-top');
var Instagram = require('./instagram');
var ProductRow = require('./product-row');

var ArtOfFit = React.createClass({

  render: function() {
    return <section ref="root" id="home-art-of-fit" className="fade-in">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6 col-sm-offset-3">
                            <img src={CMS.home.aof_img}></img>
                        </div>
                    </div>
                    <div className="row">
                        <div className="text-wrap col-sm-8 col-sm-offset-2">
                            <p className="lead">{CMS.home.aof_prefix}</p>
                            <h1>{CMS.home.aof_title}</h1>
                            <p>{CMS.home.aof_text}</p>
                            <Link to={CMS.home.aof_btnLink} className="btn btn-primary">
                              {CMS.home.aof_btnText}
                            </Link>
                        </div>
                    </div>
                </div>
      </section>
  }
});

module.exports = React.createClass({

  mixins: [ ScrollToTop ],

  componentDidMount: function() {
    Shopify.getFeatureProd(this.productsGot);
    this.scrollToTop('home-page');
  },

  productsGot: function(products) {
    this.refs.prodRow.setProducts(products);
  },

  render: function() {

    return <div>
                <TopBigImg subHeading="Shop Online Or In-Store" ref="topImg"
                           withGenderBtns={"true"} title={CMS.home.title}
                           desc={CMS.home.desc} btnText={CMS.home.btnText}
                           btnLink={CMS.home.btnLink} btn2Text={CMS.home.btn2Text}
                           btn2Link={CMS.home.btn2Link} image={CMS.home.img}
                           imageM={CMS.home.imgM} />
                <main id="content" role="main">
                    <section id="home-featured" className="hidden-xs">
                        <div className="container">
                            <ProductRow collection="featured" ref="prodRow" />
                        </div>
                    </section>
                    <div className="fade-in">
                        <SeasonSales image={CMS.home.sales_img} prefix={CMS.home.sales_prefix}
                                     title={CMS.home.sales_title} text={CMS.home.sales_text}
                                     btnText={CMS.home.sales_btnText} btnLink={CMS.home.sales_btnLink}
                                     btn2Text={CMS.home.sales_btn2Text} btn2Link={CMS.home.sales_btn2Link}/>
                    </div>
                    <ArtOfFit />
                    <Instagram/>
                </main>             
          </div>
  }
});